import { localeSetActions, localeGetActions } from "Actions/localeActions";
import appActions from "Actions/appActions";
import localeInitActions from "Actions/localeActions/localeInitActions";
import Locale from "Services/locale";
import Countries from "Services/http/countries";
import MarketsSvc from "Services/markets/marketsSvc";

const preloadActions = (function () {
    const actions = {
        preloadLocale: ({ country, language }) => {
            return (dispatch, getState) => {
                let updatedLocale = Locale.createLocale(country, language);
                dispatch(localeSetActions.setCountry(country));
                dispatch(localeSetActions.setState(null));
                dispatch(localeSetActions.setLocale(updatedLocale));
                dispatch(localeSetActions.setLanguage(language));
                dispatch(localeGetActions.getTranslations(updatedLocale));
                dispatch(appActions.setCatalogName(country));
                dispatch(localeInitActions.initFeatureFlags());
            };
        },
        preloadMarkets: wait => {
            return (dispatch, getState) => {
                dispatch(appActions.setIsLoading(true));
                Countries.get()
                    .then(res => {
                        dispatch(appActions.setIsLoading(false));
                        dispatch(localeSetActions.setCountries(res));
                        let { apiCountryData: countries } = getState().locale;
                        let markets = MarketsSvc.enrichMarketDefinitions(countries);
                        dispatch(localeSetActions.setMarkets(markets));
                        dispatch(localeGetActions.getMarketCurrency());
                        dispatch(localeGetActions.getLangOptions());
                    })
                    .fail(error => {
                        console.log(error);
                        dispatch(appActions.setIsLoading(false));
                    });
            };
        }
    };

    return actions;
})();

export default preloadActions;



// WEBPACK FOOTER //
// ./src/store/actions/preloadActions.js